/**
 * AdminProfile.js - Page profil Admin / Super Admin
 * Utilise le composant ProfilePageModern unifié
 */
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ProfilePageModern from './ProfilePageModern';

export default function AdminProfile() {
  const { user } = useAuth();
  const userType = user?.role === 'super_admin' ? 'super_admin' : 'admin';
  
  return <ProfilePageModern userType={userType} />;
}
